<!-- eslint-disable no-console -->
<template>
    <gat-grid class="mt-3 gat-grid" :items="structuredData" :columns="gridColumns" >
        <template slot="cell" slot-scope="slotprops" v-if="slotprops.column.header == 'Import'">
        <gat-edit class="gridCheckbox" v-model="slotprops.row.doImport" :checkbox="true" />
        </template>
    </gat-grid>         
        
 </template>
 
 <script >
 import Vue from "vue";
 import GatGrid from "../../../GatComponents/GatGrid.vue";
 
 
 export default Vue.extend({
    name: "StructDataView",
    components: { GatGrid},
    props: {parsedData: Object},
    data() {
       return {
        
       };
    },
 
    activated() {},
 
    mounted() {
     
    },
 
    deactivated() {},
 
    computed: {
      gridColumns() {        
        let columns = [];
        if(this.parsedData && this.parsedData.meta && this.parsedData.meta.fields.length > 0)
        for (const key in this.parsedData.meta.fields) {
            const field = this.parsedData.meta.fields[key];
            
            columns.push({ header: field, field: field });
        }  
        return columns;
      },

      structuredData(){
        return this.parsedData.data;      
      }

    },
 
    methods: {

       
      },
 });

 </script>
 
 <style scoped>
   .gridCheckbox {
      margin-top: 12px;
      margin-bottom: -12px;
   }

   .gat-grid{
    max-height: 700px;
    overflow-y: auto;
   }

 </style>
 